import { AppThunk } from 'utils'
import { NegotiationActions, NegotiationFieldMeta, NegotiationUpdateAttributes } from 'api'
import { isNil } from 'lodash'
import { userPreferenceSelector } from 'selectors/userPreferenceSelectors'

type ValueRawValueTuple = [any, any]
type UpdatedAttributes = { [P in NegotiationFieldMeta]?: ValueRawValueTuple }

const update = (payload: { negotiationIds: string[]; updatedAttributes: UpdatedAttributes }): AppThunk => async (dispatch, getState) => {
  const state = getState()
  const userPreference = userPreferenceSelector(state)

  const updatedAttributesList: NegotiationUpdateAttributes[] = payload.negotiationIds.map(negotiationId => {
    return {
      negotiationId,
      ...parseUpdatedAttributes(payload.updatedAttributes),
      meta: {
        haircutSign: userPreference.haircutSign
      }
    }
  })

  dispatch(NegotiationActions.updateValuesBulk(updatedAttributesList, true))
}

export const NegotiationsBulk = {
  update
}

const parseUpdatedAttributes = (updatedAttributes: UpdatedAttributes) => {
  return Object.entries(updatedAttributes).reduce<Pick<NegotiationUpdateAttributes, 'updatedValues' | 'updatedRawValues'>>(
    (object, [key, values]) => {
      object.updatedValues[key as NegotiationFieldMeta] = isNil(values[0]) ? undefined : values[0]
      object.updatedRawValues[key as NegotiationFieldMeta] = isNil(values[1]) ? undefined : values[1]

      return object
    },
    { updatedValues: {}, updatedRawValues: {} }
  )
}
